import { render, staticRenderFns } from "./live-view.vue?vue&type=template&id=202515b3&scoped=true&"
import script from "./live-view.vue?vue&type=script&lang=js&"
export * from "./live-view.vue?vue&type=script&lang=js&"
import style0 from "./live-view.vue?vue&type=style&index=0&id=202515b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202515b3",
  null
  
)

export default component.exports